import { UserSettingsRemoteDto } from '../../../generated/signalR/user-settings-remote-dto';
import { LanguageType } from '../../samwebDescription/samweb/settings/language-types';
import { ThemeType } from '../../samwebDescription/samweb/settings/theme-type';
import { ShortcutTypeGlobal } from '../../samwebDescription/samweb/shortcuts/shortcutTypeGlobal';
import { LongRunningContextCategoryTyp } from '../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from '../server-communication/running-actions/types/longRunningAction.decorator';

export class ToggleGlobalSettingsDialog {
   public static readonly type = '[Settings] Toggle global settings dialog';
}

export class SettingsChangeApplicationLanguage {
   public static readonly type = '[Settings] change application language';

   constructor(public applicationLanguage: LanguageType) {}
}

export class SettingsChangeTheme {
   public static readonly type = '[Settings] change theme';

   constructor(public theme: ThemeType) {}
}

export class SettingsChangeBackgroundImage {
   public static readonly type = '[Settings] change background image';

   constructor(public backgroundImageUrl: string) {}
}

export class SettingsChangeGlobalBrickScaling {
   public static readonly type = '[Settings] change global brick scaling';

   constructor(public globalBrickScaling: number) {}
}

export class SettingsChangeWarnBeforeClosingTab {
   public static readonly type = '[Settings] change warning before closing tab';

   constructor(public warnBeforeClosingTab: boolean) {}
}

export class SettingsChangedHotkeyCombo {
   public static readonly type = '[Settings] change hotkey combo';

   constructor(public shortcutType: ShortcutTypeGlobal, public combo: string) {}
}
export class SetCurrentHotkeySettings {
   public static readonly type = '[Settings] update current hotkeys';

   constructor(
      public shortcuts: {
         [key: string]: string;
      }
   ) {}
}

export class SettingsChangedByServer {
   public static readonly type = '[Settings] settings changed by server';

   constructor(public userSettings: UserSettingsRemoteDto) {}
}

export class SettingsChangeBrickWallMargin {
   public static readonly type = '[Settings] change brick wall margin';
   constructor(public margin: number) {}
}

export class SettingsChangeCanOtherUsersTriggerRequiredAgentNotification {
   public static readonly type = '[Settings] change can other users trigger required agent notification';
   constructor(public canTriggerNotification: boolean) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.SETTINGS)
export class SaveSettings {
   public static readonly type = '[Settings] save settings';

   constructor() {}
}

export class RejectChangedSettings {
   public static readonly type = '[Settings] reject changed settings';

   constructor() {}
}

export class ChangeCurrentTheme {
   public static readonly type = '[Settings] change current theme';

   constructor(public theme: ThemeType) {}
}

export class UpdateDraftSettings {
   public static readonly type = '[Settings] update draft settings';

   constructor() {}
}

export class SetTemporaryTheme {
   public static readonly type = '[Settings] set temporary theme';

   constructor(public theme: ThemeType) {}
}
